import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function CatalogBreadcrumbs({ items = [], product }) {
  return (
    <nav aria-label="مسیر صفحه" className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
      <Link to="/" className="hover:text-[#005bbb]">خانه</Link>
      {items.map((item, index) => (
        <span key={item.id || item.slug} className="inline-flex min-w-0 items-center gap-2">
          <ChevronLeft size={12} className="shrink-0" />
          {index === items.length - 1 && !product ? <span aria-current="page" className="text-slate-900">{item.title}</span> : (
            <Link className="break-words hover:text-[#005bbb]" to={`/${Number(item.level) === 1 ? 'category' : 'subcategory'}/${item.slug}`}>{item.title}</Link>
          )}
        </span>
      ))}
      {product && <span aria-current="page" className="inline-flex items-center gap-2 text-slate-900"><ChevronLeft size={12} className="shrink-0" />{product.title}</span>}
    </nav>
  );
}
